/* Object.keys impelemenation that retains the typing of the indices. Helpful if you are trying to loop through an object that has enum values as indices like {[k in MyGreatEnum]: string} */
export function keys<T extends object>(o: T): (keyof T)[] {
  // type cast should be safe because that's what really Object.keys() does
  return Object.keys(o) as (keyof T)[];
}
